export default __webpack_public_path__ + "static/media/ic_footer_login.25062093.svg";